import React from 'react'
import { useTranslation } from 'react-i18next'
import { Gem } from 'lucide-react'
import { hapticImpact } from '../../../utils/haptic'
import useCrashStore from '../store/useCrashStore'
import { calcWin } from '../utils/crashHelpers'

/**
 * Кнопка «Вывести N» со своей ставки — общая для блока CrashMyBet (desktop)
 * и кнопки действия под полем на mobile (CrashActionButton).
 *
 * Живой пересчёт amount × multiplier / 100. Блокируем сразу по клику,
 * до crash:cashout или таймаута (§8.5 — не «оптимистично»).
 * Рендерится только в фазе running при наличии невыведенной своей ставки.
 */
const CrashCashoutButton = ({ className = '' }) => {
  const { t } = useTranslation()
  const myBet = useCrashStore((s) => s.myBet)
  const phase = useCrashStore((s) => s.phase)
  const multiplierHundreds = useCrashStore((s) => s.multiplierHundreds)
  const isCashingOut = useCrashStore((s) => s.isCashingOut)
  const isConnected = useCrashStore((s) => s.isConnected)
  const cashout = useCrashStore((s) => s.cashout)
  const players = useCrashStore((s) => s.players)
  const myChatId = useCrashStore((s) => s.myChatId)

  if (!myBet || phase !== 'running') return null

  const myPlayerState = myChatId ? players.get(String(myChatId)) : null
  if (myPlayerState?.cashed) return null

  const amount = Number(myBet.amount || 0)
  const liveWin = calcWin(amount, multiplierHundreds)
  const canCashout = isConnected && !isCashingOut

  const handleCashout = () => {
    if (!canCashout) return
    // По клику — только отклик на нажатие; «успех» вибрирует store по crash:cashout (§8.5)
    if (cashout()) hapticImpact('medium')
  }

  return (
    <button
      onClick={handleCashout}
      disabled={!canCashout}
      className={`
        w-full py-3 rounded-xl font-bold transition-all tabular-nums
        flex items-center justify-center gap-1.5
        ${canCashout
          ? 'gradient-border-cta animate-gradient-shift text-dark-primary active:scale-[0.98]'
          : 'bg-dark-secondary text-text-secondary cursor-not-allowed'}
        ${className}
      `}
    >
      {!isConnected ? (
        t('realtime.reconnecting')
      ) : isCashingOut ? (
        t('crash.buttons.cashingOut')
      ) : (
        <>
          {t('crash.buttons.cashout')}
          <Gem className="w-4 h-4" />
          {liveWin.toLocaleString('ru-RU')}
        </>
      )}
    </button>
  )
}

export default CrashCashoutButton
